/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getCompanyDetails as getCompanyDetailsService,
  updateCompanyDetails as updateCompanyDetailsService,
} from 'dashboard409a/services/company';
import { IGetCompanyDetailsResponse } from 'dashboard409a/services/types';
import { selectDashboardCompany } from 'dashboard409a/states/features/global';
import { ICompanyState } from './types';

const initialState: ICompanyState = {
  companyDetails: null,
};

export const getCompanyDetails = createAsyncThunk<IGetCompanyDetailsResponse, number>(
  'company/getCompanyDetails',
  async (companyId, thunkAPI) => {
    try {
      return await getCompanyDetailsService(companyId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateCompanyDetails = createAsyncThunk(
  'company/updateCompanyDetails',
  async (companyDetails: IGetCompanyDetailsResponse, thunkAPI) => {
    try {
      return (await updateCompanyDetailsService(companyDetails)) as unknown as IGetCompanyDetailsResponse;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(selectDashboardCompany, () => initialState);
    builder.addCase(getCompanyDetails.pending, (state, action) => {
      state.companyDetails = null;
      state.companyDetailsRequestId = action.meta.requestId;
    });
    builder.addCase(getCompanyDetails.fulfilled, (state, action) => {
      if (state.companyDetailsRequestId === action.meta.requestId) {
        state.companyDetails = action.payload;
        state.companyDetailsRequestId = undefined;
      }
    });
    builder.addCase(getCompanyDetails.rejected, (state, action) => {
      if (state.companyDetailsRequestId === action.meta.requestId) {
        state.companyDetailsRequestId = undefined;
      }
    });
    builder.addCase(updateCompanyDetails.pending, (state, action) => {
      state.companyDetailsRequestId = action.meta.requestId;
    });
    builder.addCase(updateCompanyDetails.fulfilled, (state, action) => {
      if (state.companyDetailsRequestId === action.meta.requestId) {
        state.companyDetails = action.payload;
        state.companyDetailsRequestId = undefined;
      }
    });
    builder.addCase(updateCompanyDetails.rejected, (state, action) => {
      if (state.companyDetailsRequestId === action.meta.requestId) {
        state.companyDetailsRequestId = undefined;
      }
    });
  },
});

export default companySlice.reducer;
